const nameWriter = () => {
  // Constants for elements
  const el = document.querySelector('input[name="name"]');
  const placeholders = document.querySelectorAll("span.name-placeholder");
  const elmSpacers = document.querySelectorAll("span.name-placeholder-spacing");
  // Set initial data value
  let dataValue = "";

  // Event listener for input changes
  if (el !== null) {
    el.addEventListener("input", (event) => {
      dataValue = event.target.value;
      updateElements(dataValue);
    });

    el.addEventListener("blur", () => {
      setCookie("name", dataValue);
    });
  }

  // Function to set a cookie
  const setCookie = (cookieName, cookieValue) => {
    const expireDate = new Date();
    expireDate.setTime(expireDate.getTime() + 14 * 24 * 60 * 60 * 1000); // 14 days
    document.cookie = `${cookieName}=${encodeURIComponent(cookieValue)};expires=${expireDate.toGMTString()}`;
  };

  // Function to get a cookie by name
  const getCookie = (cookieName) => {
    const nameEQ = cookieName + "=";
    const cookies = document.cookie.split(";");

    for (const cookie of cookies) {
      const c = cookie.trim();
      if (c.startsWith(nameEQ)) {
        return decodeURIComponent(c.substring(nameEQ.length));
      }
    }

    return "";
  };

  // Function to update elements with the value
  const updateElements = (value) => {
    if (el !== null) {
      el.value = value;
    }

    elmSpacers.forEach((elm) => {
      elm.classList.toggle("d-none", value === "");
    });

    placeholders.forEach((placeholder) => {
      placeholder.textContent = value || placeholder.getAttribute("data-initial");
    });
  };

  // Function to check and update the cookie value
  const checkAndUpdateCookie = (cookieName) => {
    const cookieValue = getCookie(cookieName);

    if (cookieValue) {
      dataValue = cookieValue;
      updateElements(dataValue);

      if (el !== null) {
        el.value = dataValue;
      }
    }
  };

  // Check for the 'name' cookie when the DOM is loaded
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      checkAndUpdateCookie("name");
    });
  } else {
    checkAndUpdateCookie("name");
  }
};

export default nameWriter;
